// extracted by mini-css-extract-plugin
export var cartContainer = "_jn-4";
export var gray = "_jn-1";
export var itemContainer = "_jn-2";
export var itemDetails = "_jn-3";
export var strong = "_jn-0";